import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import SystemHeader from '../SystemHeader';

// Dùng chung cho 4 trang Khen thưởng (STT 20): /khenthuong, /khenthuong/:ma, form + tình trạng Du lịch 2026.
// Nhãn trạng thái phải khớp cột dl_2026_detail.trang_thai — 3 giá trị cho_duyet | phe_duyet | tu_choi (anh Bình chốt 15/09/2026).

export const fmtTien = (n) => `${(Number(n) || 0).toLocaleString('vi-VN')} đ`;

// 1.670.000.000 → "1,67 tỷ", 632.000.000 → "632 tr" — dùng ở chỗ hẹp (thẻ card, badge)
export const fmtTienNgan = (n) => {
  const v = Number(n) || 0;
  if (v >= 1e9) return `${(v / 1e9).toLocaleString('vi-VN', { maximumFractionDigits: 2 })} tỷ`;
  if (v >= 1e6) return `${Math.round(v / 1e6).toLocaleString('vi-VN')} tr`;
  return v.toLocaleString('vi-VN');
};

// '2026-11-15' → '15/11/2026'
export const fmtNgay = (iso) => (iso ? `${String(iso).slice(8, 10)}/${String(iso).slice(5, 7)}/${String(iso).slice(0, 4)}` : '—');
// '2026-11-15' → '15/11' (chỗ hẹp)
export const fmtNgayNgan = (iso) => (iso ? `${String(iso).slice(8, 10)}/${String(iso).slice(5, 7)}` : '');

// Số ngày còn lại tới hết ngày iso (theo ngày, không theo giờ). Âm = đã qua hạn.
export const soNgayCon = (iso) => {
  if (!iso) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const end = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  return Math.round((end - today) / 86400000);
};

export const TRANG_THAI = {
  cho_duyet: { label: 'Chờ duyệt', cls: 'bg-amber-100 text-amber-800 border-amber-200', icon: 'hourglass_top' },
  phe_duyet: { label: 'Đã duyệt', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200', icon: 'verified' },
  tu_choi: { label: 'Từ chối', cls: 'bg-red-100 text-red-700 border-red-200', icon: 'cancel' },
};

// Chiến dịch tinh_trang='dong' hiện trên app là "Sắp mở" (anh Bình chốt 12/09/2026) — admin vẫn ghi Mở/Đóng.
export const nhanTinhTrang = (tinhTrang) => (tinhTrang === 'mo' ? 'Đang mở đăng ký' : 'Sắp mở');

export const PHUONG_TIEN = [
  { value: 'may_bay', label: 'Máy bay', icon: 'flight' },
  { value: 'o_to_nha', label: 'Ô tô nhà', icon: 'directions_car' },
  { value: 'xe_khach', label: 'Xe khách', icon: 'directions_bus' },
  { value: 'khac', label: 'Khác', icon: 'more_horiz' },
];
export const tenPhuongTien = (v) => PHUONG_TIEN.find((p) => p.value === v)?.label || '—';

// Màu dải trên thẻ theo thứ tự chiến dịch (6 chiến dịch 2026 → 6 màu, quay vòng nếu thêm)
export const MAU_THE = [
  'linear-gradient(135deg, #B91C1C, #F97316)',
  'linear-gradient(135deg, #1D4ED8, #06B6D4)',
  'linear-gradient(135deg, #7C3AED, #EC4899)',
  'linear-gradient(135deg, #047857, #84CC16)',
  'linear-gradient(135deg, #B45309, #FBBF24)',
  'linear-gradient(135deg, #0F766E, #3B82F6)',
];

export const Icon = ({ name, size = 16, className = '' }) => (
  <span className={`material-symbols-rounded ${className}`} style={{ fontSize: `${size}px`, lineHeight: 1 }}>{name}</span>
);

export const TrangThaiChip = ({ trangThai, size = 'sm' }) => {
  const t = TRANG_THAI[trangThai];
  if (!t) return null;
  const pad = size === 'lg' ? 'px-3 py-1.5 text-[13px]' : 'px-2 py-0.5 text-[11px]';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border font-bold ${pad} ${t.cls}`}>
      <Icon name={t.icon} size={size === 'lg' ? 16 : 13} />{t.label}
    </span>
  );
};

// Khối KẾT QUẢ nổi bật — đầu thẻ /khenthuong và đầu trang tình trạng (anh Bình 15/09/2026: "vào phát là nhìn thấy ngay").
// hoSo = hoSoCuaToi (BE decorateForApp) hoặc hoSo (getCuaToi): cần trangThai, maDangKy, ghiChuDuyet (= lý do khi Từ chối).
const KET_QUA = {
  cho_duyet: { bg: 'linear-gradient(135deg, #B45309, #F59E0B)', icon: 'hourglass_top', tieuDe: 'Chờ duyệt' },
  phe_duyet: { bg: 'linear-gradient(135deg, #047857, #10B981)', icon: 'verified', tieuDe: 'Đã duyệt' },
  tu_choi: { bg: 'linear-gradient(135deg, #991B1B, #EF4444)', icon: 'cancel', tieuDe: 'Từ chối' },
};
export const KetQuaHoSo = ({ hoSo, batDauDuyet, ketThucDuyet }) => {
  const k = hoSo && KET_QUA[hoSo.trangThai];
  if (!k) return null;
  const lich = batDauDuyet && ketThucDuyet ? ` ${fmtNgayNgan(batDauDuyet)} – ${fmtNgayNgan(ketThucDuyet)}` : '';
  const phu = hoSo.trangThai === 'cho_duyet' ? `Hồ sơ đã nộp · ban tổ chức xét duyệt${lich}`
            : hoSo.trangThai === 'phe_duyet' ? 'Chúc mừng! Bạn đủ điều kiện tham gia chuyến đi'
            : 'Hồ sơ chưa đạt · xem lý do bên dưới';
  return (
    <div className="rounded-2xl px-3 py-2.5 text-white shadow-md" style={{ background: k.bg }}>
      <div className="flex items-center gap-2.5">
        <span className="w-11 h-11 rounded-full bg-white/25 flex items-center justify-center flex-shrink-0"><Icon name={k.icon} size={26} /></span>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-bold uppercase tracking-wider text-white/80">Kết quả hồ sơ {hoSo.maDangKy}</p>
          <p className="text-[20px] font-black leading-tight">{k.tieuDe}</p>
          <p className="text-[11px] font-semibold text-white/90 leading-tight">{phu}</p>
        </div>
      </div>
      {hoSo.ghiChuDuyet && (
        <div className="mt-2 rounded-xl bg-white/15 border border-white/30 px-2.5 py-1.5">
          <p className="text-[10px] font-bold uppercase text-white/80">{hoSo.trangThai === 'tu_choi' ? 'Lý do từ chối' : 'Ghi chú từ ban tổ chức'}</p>
          <p className="text-[13px] font-semibold whitespace-pre-line">{hoSo.ghiChuDuyet}</p>
        </div>)}
    </div>
  );
};

// Hành trình 4 bước Đăng ký → Đủ điều kiện → Xét duyệt → Kết quả (anh Bình chốt 15/09/2026, thay bản 3 bước).
// trangThai null = chưa đăng ký. Prop duDkDoanhSo: nơi gọi truyền BE `duDk` = đạt 1 trong 2 yêu cầu (doanh số HOẶC tuyển sỉ, 28/09/2026) → bước 2 đổi màu theo thời gian.
// Màu bước: xong (xanh, tick) · dang (vàng, đang ở đây) · chua (cam, chưa đủ ĐK) · hong (đỏ, từ chối) · cho (xám, chưa tới).
const MAU_BUOC = {
  xong: 'bg-gradient-to-br from-emerald-400 to-emerald-700 text-white shadow-md',
  dang: 'bg-gradient-to-br from-amber-300 to-orange-500 text-white shadow-md ring-4 ring-amber-200',
  chua: 'bg-gradient-to-br from-orange-400 to-red-500 text-white shadow-md ring-4 ring-orange-200',
  hong: 'bg-gradient-to-br from-red-400 to-red-700 text-white shadow-md ring-4 ring-red-200',
  cho: 'bg-gray-200 text-gray-400',
};
const CHU_BUOC = { xong: 'text-emerald-800', dang: 'text-amber-800', chua: 'text-orange-700', hong: 'text-red-700', cho: 'text-gray-400' };

export const HanhTrinh = ({ trangThai, duDkDoanhSo, batDauDuyet, ketThucDuyet, size = 'md' }) => {
  const daNop = !!trangThai;
  const coKetQua = trangThai === 'phe_duyet' || trangThai === 'tu_choi';
  const lich = batDauDuyet && ketThucDuyet ? ` ${fmtNgayNgan(batDauDuyet)} – ${fmtNgayNgan(ketThucDuyet)}` : '';
  const BUOC = [
    { icon: 'how_to_reg', label: daNop ? 'Đã đăng ký' : 'Đăng ký', tt: daNop ? 'xong' : 'dang' },
    { icon: 'payments', label: !daNop ? 'Đủ điều kiện?' : duDkDoanhSo ? 'Đủ điều kiện' : 'Chưa đủ điều kiện',
      tt: !daNop ? 'cho' : duDkDoanhSo ? 'xong' : 'chua' },
    { icon: 'hourglass_top', label: `Xét duyệt${lich}`, tt: coKetQua ? 'xong' : daNop ? 'dang' : 'cho' },
    { icon: coKetQua ? TRANG_THAI[trangThai].icon : 'emoji_events', label: coKetQua ? TRANG_THAI[trangThai].label : 'Kết quả',
      tt: trangThai === 'phe_duyet' ? 'xong' : trangThai === 'tu_choi' ? 'hong' : 'cho' },
  ];
  const lon = size === 'lg';
  const vong = lon ? 'w-11 h-11' : 'w-9 h-9';
  return (
    <div className="flex items-start">
      {BUOC.map((b, i) => (
        <React.Fragment key={b.label}>
          <div className="flex flex-col items-center flex-1 min-w-0">
            <div className={`${vong} rounded-full flex items-center justify-center ${MAU_BUOC[b.tt]}`}>
              <Icon name={b.tt === 'xong' && i < 3 ? 'check' : b.icon} size={lon ? 22 : 18} />
            </div>
            <p className={`mt-1 ${lon ? 'text-[11px]' : 'text-[10px]'} font-bold text-center leading-tight ${CHU_BUOC[b.tt]}`}>{b.label}</p>
          </div>
          {i < BUOC.length - 1 && (
            <div className={`h-1 flex-1 ${lon ? 'mt-5' : 'mt-4'} -mx-3 rounded ${b.tt === 'xong' ? 'bg-emerald-500' : 'bg-gray-200'}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

// Nhãn nổi bật "Đạt 1 trong 2 yêu cầu" + dòng "hoặc" — đặt trước/giữa yêu cầu doanh số và yêu cầu tuyển sỉ
export const NhanMotTrongHai = () => (
  <div className="flex items-center gap-2">
    <div className="h-px flex-1 bg-red-200" />
    <span className="rounded-full bg-red-600 text-white px-3 py-1 text-[12px] font-black uppercase tracking-wide shadow">Đạt 1 trong 2 yêu cầu</span>
    <div className="h-px flex-1 bg-red-200" />
  </div>
);
export const Hoac = () => <p className="text-center text-[12px] font-black text-gray-400 uppercase tracking-widest">— hoặc —</p>;

// Yêu cầu tuyển sỉ (anh Bình chốt 28/09/2026) — khung ngắn gọn, không thanh tiến độ ("thông tin ít, tập trung").
// tuyenSi = BE tuyenSiCua(): ds[] sỉ mới (F1 duyệt, vào từ 01/10) · dsDau = ĐƠN DS DUYỆT ĐẦU TIÊN (không cộng dồn) · dat = dsDau ≥ 6tr.
// Số tiền in đủ (fmtTien), KHÔNG dùng fmtTienNgan — nó làm tròn 5,6tr thành "6 tr", nhìn tưởng đạt.
export const YeuCauTuyenSi = ({ tuyenSi, so = '3' }) => {
  if (!tuyenSi) return null;
  const { ds = [], soDat = 0, canDat = 3, dsToiThieu = 6000000, tuNgay } = tuyenSi;
  const dat = soDat >= canDat;
  return (
    <div className={`rounded-2xl border-2 px-4 py-3 ${dat ? 'border-emerald-500 bg-emerald-50' : 'border-amber-400 bg-amber-50'}`}>
      <div className="flex items-start gap-2">
        <span className={`flex-shrink-0 w-7 h-7 rounded-full text-white text-[13px] font-black flex items-center justify-center ${dat ? 'bg-emerald-600' : 'bg-amber-500'}`}>{so}</span>
        <div className="flex-1 min-w-0">
          <p className="text-[15px] font-black text-gray-900 leading-tight">Yêu cầu tuyển sỉ</p>
          <p className="text-[12px] text-gray-600">Tuyển {canDat} sỉ mới · vào từ {fmtNgay(tuNgay)} · đơn doanh số được duyệt đầu tiên từ {fmtTien(dsToiThieu)}</p>
        </div>
        <span className={`flex-shrink-0 text-[22px] font-black leading-none ${dat ? 'text-emerald-700' : 'text-amber-700'}`}>{soDat}<span className="text-[14px]">/{canDat}</span></span>
      </div>
      {ds.length > 0 && (
        <div className="mt-2 rounded-xl bg-white border border-gray-200 divide-y divide-gray-100">
          {ds.map((s) => (
            <div key={s.userId} className="flex items-center justify-between gap-2 px-3 py-1.5 text-[12px]">
              <span className="font-bold text-gray-800 truncate">{s.codeFacebook}</span>
              <span className={`flex-shrink-0 font-bold ${s.dat ? 'text-emerald-700' : 'text-gray-500'}`}>
                {s.dsDau == null ? 'Chưa có đơn duyệt' : `${fmtTien(s.dsDau)} ${s.dat ? '✔' : '✗'}`}
              </span>
            </div>
          ))}
        </div>
      )}
      <p className={`mt-2 text-[12px] font-bold ${dat ? 'text-emerald-700' : 'text-amber-800'}`}>
        {dat ? 'Đã đạt yêu cầu tuyển sỉ' : `Còn thiếu ${canDat - soDat} sỉ đạt`}
      </p>
    </div>
  );
};

// file_quy_dinh (loai_khen_thuong, admin sửa được): 1 hoặc nhiều đường dẫn cách nhau dấu phẩy.
// Ảnh (.jpg/.png/.webp) → xem ngay trong modal; loại khác (.pdf, link) → mở tab mới. Ảnh Du lịch 2026: PE_Form/public/quy-dinh/du-lich-2026/.
export const dsQuyDinh = (s) => String(s || '').split(',').map((x) => x.trim()).filter(Boolean);
const laAnh = (u) => /\.(jpe?g|png|webp|gif)(\?.*)?$/i.test(u);

export const NutXemQuyDinh = ({ fileQuyDinh, kieu = 'pill' }) => {
  const [mo, setMo] = useState(false);
  useEffect(() => {
    if (!mo) return undefined;
    const phimEsc = (e) => e.key === 'Escape' && setMo(false);
    window.addEventListener('keydown', phimEsc);
    return () => window.removeEventListener('keydown', phimEsc);
  }, [mo]);
  const ds = dsQuyDinh(fileQuyDinh);
  if (!ds.length) return null;
  const chan = (e) => e.stopPropagation(); // nút nằm trong thẻ bấm được (mở chi tiết) → không cho nổi bọt lên thẻ
  const moModal = (e) => { chan(e); setMo(true); };
  const dong = (e) => { chan(e); setMo(false); };
  return (
    <>
      {kieu === 'khoi' ? (
        <button type="button" onClick={moModal}
                className="flex-shrink-0 w-[74px] rounded-xl border border-blue-200 bg-blue-50 text-blue-700 flex flex-col items-center justify-center gap-0.5 active:bg-blue-100">
          <Icon name="gavel" size={20} />
          <span className="text-[10px] font-bold leading-tight text-center">Xem quy định</span>
        </button>
      ) : (
        <button type="button" onClick={moModal}
                className="flex-shrink-0 inline-flex items-center gap-1 rounded-full bg-blue-600 text-white px-2.5 py-1 text-[11px] font-bold">
          <Icon name="gavel" size={14} />Xem quy định
        </button>
      )}
      {mo && createPortal(
        // Portal ra body: thẻ cha có active:scale (transform) → modal fixed nằm trong thẻ bị co vào thẻ đúng lúc đè ✕ → click không sinh, không đóng được (lỗi anh Bình báo 15/09/2026).
        // Bấm nền tối / ✕ / Đóng / Escape đều đóng; bấm vào ảnh thì không.
        <div className="fixed inset-0 z-50 bg-black/90 flex flex-col" onClick={dong}>
          <div className="flex items-center justify-between px-3 py-2 text-white">
            <p className="text-[14px] font-bold flex items-center gap-1.5"><Icon name="gavel" size={18} />Quy định xét thưởng</p>
            <button type="button" aria-label="Đóng" onClick={dong} className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center active:bg-white/40"><Icon name="close" size={22} /></button>
          </div>
          <div className="flex-1 overflow-y-auto px-2 pb-8">
            <div className="max-w-3xl mx-auto space-y-2">
              {ds.map((u, i) => (laAnh(u)
                ? <img key={u} src={u} alt={`Quy định trang ${i + 1}`} onClick={chan} className="w-full rounded-lg bg-white" />
                : <a key={u} href={u} target="_blank" rel="noreferrer" onClick={chan} className="block rounded-xl bg-white text-blue-700 font-bold text-[14px] px-3 py-3 text-center">Mở tệp quy định {i + 1}</a>))}
              <button type="button" onClick={dong} className="w-full rounded-xl bg-white text-gray-800 font-bold text-[14px] py-3">Đóng</button>
            </div>
          </div>
        </div>,
        document.body)}
    </>
  );
};

// Khung trang: SystemHeader + thanh Quay lại. backTo mặc định /khenthuong.
export const PageShell = ({ userInfo, onLogout, totalPoints, onRefreshPoints, title, backTo = '/khenthuong', children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pb-10">
      <SystemHeader userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} pageTitle={title} onRefreshPoints={onRefreshPoints} />
      <div className="flex items-center gap-3 px-3 py-2 bg-white border-b border-gray-200 sticky top-0 z-10">
        <button type="button" onClick={() => navigate(backTo)}
                className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium text-red-700 bg-red-50 hover:bg-red-100">
          <Icon name="arrow_back" size={14} /><span>Quay lại</span>
        </button>
        <h1 className="text-sm font-semibold text-red-900 flex-1 truncate">{title}</h1>
      </div>
      {children}
    </div>
  );
};

export const Avatar = ({ src, name, size = 64 }) => (
  src
    ? <img src={src} alt="" className="rounded-full object-cover border-4 border-white shadow-lg" style={{ width: size, height: size }} />
    : <div className="rounded-full bg-white/30 border-4 border-white shadow-lg flex items-center justify-center font-black text-white"
           style={{ width: size, height: size, fontSize: size / 2.5 }}>{(name || '?').trim().charAt(0).toUpperCase()}</div>
);
